// src/sectors/pilates/attendance/ui/AttendanceMarkModal/attendanceConstants.js

/** UI statuses */
export const S = {
  PENDING: 'PENDING',
  PRESENT: 'PRESENT',
  ABSENT: 'ABSENT',
  CANCELLED: 'CANCELLED',
  BURN: 'BURN',
};

export const META = {
  [S.PENDING]: {
    label: 'Beklemede',
    icon: 'hourglass_empty',
    colorKey: 'info',
    help: 'Henüz yoklama alınmadı.',
  },
  [S.PRESENT]: {
    label: 'Katıldı',
    icon: 'check_circle',
    colorKey: 'success',
    help: 'Katıldı: Ders yapıldı.',
  },
  [S.ABSENT]: {
    label: 'Katılmadı',
    icon: 'cancel',
    colorKey: 'error',
    help: 'Katılmadı: normal haktan düşebilir.',
  },
  [S.CANCELLED]: {
    label: 'İptal',
    icon: 'event_busy',
    colorKey: 'warning',
    help: 'İptal: hak düşmez.',
  },
  [S.BURN]: {
    label: 'Seansı yak',
    icon: 'local_fire_department',
    colorKey: 'warning',
    help: 'Yak: tamamlanmış sayılır.',
  },
};
